import React, { useState } from "react";
import UpdateDeleteModal from "../../../globalComponents/Modals/UpdateDeleteModal/UpdateDeleteModal";
import { useDispatch } from "react-redux";
import { deleteStudentPerformanceResult, updateStudentPerformanceResult } from "../../../redux/actions/studentPerformanceActions";
import { STUDENT_PERFORMANCE_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import DeleteItemModal from "../../../globalComponents/Modals/DeleteItemModal/DeleteItemModal";

const StudentPerformanceCard = ({ monthData: data }) => {
  const dispatch = useDispatch();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // hansı gün edit modundadır
  const [editingOrder, setEditingOrder] = useState(null);
  // input dəyəri
  const [inputValue, setInputValue] = useState("");

  const deleteItem = () => {
    dispatch(deleteStudentPerformanceResult(data._id));
  };


   const getOrdinalSuffix = (num) => {
    const lastDigit = num % 10;
    const lastTwoDigits = num % 100;

    // 10, 20, 30...
    if ([10, 20, 30, 40, 50, 60, 70, 80, 90].includes(lastTwoDigits)) {
      return "cu";
    }

    switch (lastDigit) {
      case 1:
      case 2:
      case 5:
      case 7:
          case 8:
        return "ci";
      case 3:
      case 4:
      case 11:
      case 12:
        return "cü";
      case 6:
        return "cı";
      case 9:
      case 10:
        return "cu";
      default:
        return "ci";
    }
  };

  const updateItem = () => {
    dispatch({
      type: STUDENT_PERFORMANCE_MODAL_ACTION_TYPE.GET_STUDENT_PERFORMANCE_MODAL,
      payload: {
        data,
        openModal: true,
      },
    });
  };

  // günə click — edit modu aç
  const handleDayClick = (day) => {
    setEditingOrder(day.order);
    setInputValue(day.point === null ? "" : String(day.point));
  };

  // dəyəri parse et
  const parsePoint = (value) => {
    if (value === "") return null;
    if (value.toLowerCase() === "x") return "x";
    if (!isNaN(Number(value))) return Number(value);
    return null;
  };

  // Enter və ya blur zamanı save et
  const handleSave = (day) => {
    const newPoint = parsePoint(inputValue);

    // dəyər dəyişməyibsə sorğu göndərmə
    if (newPoint === day.point) {
      setEditingOrder(null);
      return;
    }

    // yenilənmiş days array-i
    const updatedDays = data.days.map((d) =>
      d.order === day.order
        ? { order: d.order, point: newPoint }
        : { order: d.order, point: d.point }
    );

    dispatch(
      updateStudentPerformanceResult(data._id, {
        month:data.month,
        days: updatedDays,
      })
    );

    setEditingOrder(null);
  };


  const handleInputChange = (e) => {
  const value = e.target.value;

  // Boş olmasına icazə ver
  if (value === "") {
    setInputValue("");
    return;
  }
    if (value.toLowerCase() === "x") {
    setInputValue(value);
    return;
  }

  const number = Number(value);

  if (number >= 0 && number <= 100) {
    setInputValue(value);
  }
};

  // Escape — ləğv et
  const handleKeyDown = (e, day) => {
    if (e.key === "Enter") handleSave(day);
    if (e.key === "Escape") setEditingOrder(null);
  };

  return (
    <>
      {showDeleteModal && (
        <DeleteItemModal
          setShowDeleteModal={setShowDeleteModal}
          deleteItem={deleteItem}
        />
      )}

      <tr>
        <td style={{textTransform:"initial"}}>{data.month}-{getOrdinalSuffix(data.month)}</td>

        {data.days.map((day, dayIndex) => (
          <td
            key={dayIndex}
            onClick={() => handleDayClick(day)}
            style={{ cursor: "pointer", minWidth: "60px" }}
          >
            {editingOrder === day.order ? (
              <input
                autoFocus
                value={inputValue}
                onChange={handleInputChange}
                onBlur={() => handleSave(day)}
                onKeyDown={(e) => handleKeyDown(e, day)}
                style={{
                  width: "50px",
                  fontSize: "12px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  padding: "2px 4px",
                  outline: "none",
                }}
              />
            ) : (
              <span>{day.point ?? "-"}</span>
            )}
          </td>
        ))}

        <td>{data.averagePoint}</td>
        <td>
          <UpdateDeleteModal
            updateItem={updateItem}
            deleteItem={deleteItem}
            data={data}
            profil="student-performance"
            setShowDeleteModal={setShowDeleteModal}
          />
        </td>
      </tr>
    </>
  );
};

export default StudentPerformanceCard;